export default "__VITE_ASSET__BbFp$qi7__"